import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken, getLoginName, setLoginName } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    userName: getLoginName(),
    avatar: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, userName) => {
    state.userName = userName
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_LOGINNAME: (state, loginName) => {
    state.loginName = loginName
  }
}

const actions = {
  // 处理登录
  async login({ commit }, userInfo) {
    // const { username, password } = userInfo
    const { loginName, password } = userInfo
    // let result = await login({ username: username.trim(), password: password });
    let result = await login({ loginName: loginName.trim(), password: password });
    if(result.code == 20000) {
      console.log(result.data);
      commit('SET_TOKEN', result.data);
      commit('SET_LOGINNAME', loginName)
      setToken(result.data);
      setLoginName(loginName);
      return 'ok';
    }else {
      alert('账号或密码不存在')
      return Promise.reject(new Error('faile'));
    }
  },

  // 获取用户数据
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token, state.loginName).then(response => {
        const { data } = response
        if (!data) {
          return reject('验证失败，请重新登录')
        }
        const { userName, avatar } = data
        commit('SET_NAME', userName)
        commit('SET_AVATAR', avatar)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 退出登录
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken() // 必须先移除token
        resetRouter()
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 移除token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // 必须先移除token
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

